export const archiveSupportConfig = [
    { controller: 'publicMerchants', entity: 'merchant' },
    { controller: 'publicMerchantTerminals', entity: 'merchantTerminal' },
    { controller: 'publicMerchantTerminalGateways', entity: 'merchantTerminalGateway' },
    { controller: 'publicGateways', entity: 'gateway' },
    { controller: 'publicGatewaySettings', entity: 'gatewaySettings' }
];

